import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("nd_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function authToken() {
  return localStorage.getItem("nd_token");
}

export default api;
